/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import styled from "styled-components";

import {
	columnWrapper,
	ellipsis,
	rowWrapper
} from "../../styled/styled-extends";
import { 
	setFont,
	setPosition
} from "../../styled/styled-mixins";
import {
	typo
} from "../../styled/styled-variables";

// EXPORT

export const MessageListInnerWrapper = styled.div`
	align-items: center;
	align-self: normal;
	background-color: #FFF;
	border-right: 1px solid #C5C5C5;
	width: 100%;
	min-height: 100vh;
	min-height: -webkit-fill-available;
	${setPosition(
		"fixed", 
		{
			"bottom": 0,
			"left": 0,
			"top": "56px",
			"z-index": 1
		}
	)}
	${columnWrapper}
`;

export const MessageListInnerFooterWrapper = styled.div`
`;

export const MessageListItem = styled.div`
	align-items: center;
	cursor: pointer;
	gap: 12px;
	padding: 16px;
	width: 100%;
	${rowWrapper}
`;

export const MessageListItemContent = styled.div`
	flex: 1;
	${columnWrapper}

	> strong {
		color: #000;
	}
`;

export const MessageListItemUnreadWrapper = styled.div`
	background-color: red; //...
	border-radius: 999px;
	height: 8px;
	width: 8px;
	${rowWrapper}
`;

export const MessageListItemWrapper = styled.div`
	flex: 1;
	overflow-y: auto;
	width: 100%;
	${columnWrapper}

	> div {
		&:not(:first-child) {
			border-top: 1px solid #DDD;
		}
	}
`;

export const MessageListWrapper = styled.div`
	align-items: center;
	align-self: normal;
	width: 100%;
	${columnWrapper}
`;




export const MessageWrapper = styled.div`
	justify-content: center;
	padding: 16px;
	width: 100%;
	${rowWrapper}
`;

export const ComponentWrapper = styled.div`
	align-items: flex-start;
	height: 100%;
	min-height: 100%;
	width: 100%;
	${rowWrapper}
	${setPosition("relative")}

	.messageCardBody {
		align-items: flex-start;
		text-align: left;

		p {
			padding-top: 16px;
			white-space: pre-wrap;
		}
	}

	.messageCardFooter {
		.button {
			width: 100%;
		}
	}

	.messageCardHeader {
		padding: 0 !important;

		img {
			left: unset;
			max-width: 100%;
			position: unset;
			top: unset;
			transform: unset;
		}
	}

	@media only screen and (min-width: 390px) {
	}

	@media only screen and (min-width: 576px) {
		${MessageWrapper} {
			padding: 24px;
		}
	}

	@media only screen and (min-width: 768px) {
		${MessageListInnerWrapper},
		${MessageListWrapper} {
			max-width: 320px;
		}
	}

	@media only screen and (min-width: 1024px) {
		${MessageWrapper} {
			padding: 32px;
		}
	}

	@media only screen and (min-width: 1280px) {
		${MessageWrapper} {
			padding: 40px;
		}
	}

	@media only screen and (min-width: 1440px) {
		${MessageWrapper} {
			padding: 48px;
		}
	}

	${(props) => {
		const {
			backgroundColors,
			body,
			card,
			header,
			typoColors
		} = props.theme;

		let loaderWrapperOpacity = 0;
		let loaderWrapperPointerEvents = "none";

		if(props.loaderActive) {
			loaderWrapperOpacity = 1;
			loaderWrapperPointerEvents = "auto";
		}

		return `
			background-color: ${body.background};
		`;
	}};
`;
